import { CircularProgress } from '@mui/material';
import classNames from 'classnames';
import type { ReactElement } from 'react';
import { LogicalDeviceSummaryCard } from '../logical-device-summary-card/LogicalDeviceSummaryCard.ctrl';
import type { MyTerminalDetailedCardProps, MyTerminalsDetailedListProps } from './myTerminalsDetailedList.model';
import styles from './myTerminalsDetailedList.module.scss';

export function MyTerminalDetailedCard({
  general,
  connectivity,
  hardware,
  isMultiple,
  customClassName,
  displayEmptyAsDash,
  isLoadingRefreshButton,
  onClickRefresh,
  hideInfo = [],
  hiddenConnectivity,
  hideConnectivityStatusChip,
  image,
}: MyTerminalDetailedCardProps): ReactElement {
  return (
    <LogicalDeviceSummaryCard
      componentsClassNames={{
        card: classNames(
          styles.card,
          {
            [styles.card__single]: !isMultiple,
            [styles.card__multiple]: isMultiple,
          },
          customClassName?.card,
        ),
        divider: classNames(styles.divider, customClassName?.divider),
        connectivityDivider: classNames(styles.connectivityDivider, customClassName?.connectivityDivider),
        connectivityContainer: classNames(styles.connectivityContainer, customClassName?.connectivityContainer),
        hardwareContainer: classNames(styles.hardwareContainer, customClassName?.hardwareContainer),
        connectivityItem: classNames(styles.connectivityItem, customClassName?.connectivityItem),
        hardwareChartsContainer: classNames(styles.hardwareChartsContainer, customClassName?.hardwareChartsContainer),
        hardwareChartsItemContainer: classNames(
          styles.hardwareChartsItemContainer,
          customClassName?.hardwareChartsItemContainer,
        ),
        hardwareInfoSectionContainer: classNames(
          styles.hardwareInfoSectionContainer,
          customClassName?.hardwareInfoSectionContainer,
        ),
        image: classNames(styles.image, customClassName?.image),
        imageContainer: classNames(styles.imageContainer, customClassName?.imageContainer),
        statusChipContainer: classNames(customClassName?.statusChipContainer),
        isScreenLockedChipContainer: classNames(customClassName?.isScreenLockedChipContainer),
      }}
      connectivity={connectivity}
      displayEmptyAsDash={displayEmptyAsDash}
      general={general}
      hardware={hardware}
      hideConnectivityStatusChip={hideConnectivityStatusChip}
      hiddenConnectivity={hiddenConnectivity}
      hideInfo={hideInfo}
      image={image}
      isLoadingRefreshButton={isLoadingRefreshButton}
      onClickRefresh={onClickRefresh}
    />
  );
}

export function MyTerminalsDetailedList({
  devices,
  onElementClick,
  isLoading = false,
}: MyTerminalsDetailedListProps): ReactElement {
  if (isLoading) {
    return (
      <div className={styles.loadingContainer}>
        <CircularProgress />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      {devices.map(({ id, general, connectivity, hardware }) => (
        <button
          className={classNames(styles.cardWraper, {
            [styles.cardWraper__clickable]: !!onElementClick,
          })}
          key={id}
          onClick={() => onElementClick?.(id)}
          type="button"
        >
          <MyTerminalDetailedCard
            connectivity={connectivity}
            displayEmptyAsDash
            general={general}
            hardware={hardware}
            hiddenConnectivity={['bluetooth', 'SIM']}
            hideInfo={['connectivityStatus', 'family', 'manufacturer']}
            isMultiple={devices.length > 1}
          />
        </button>
      ))}
    </div>
  );
}
